export default function desktopSearch() {
    const burgerIcons = document.querySelectorAll(".desktop-search");
    const fullSearch = document.querySelector(".full-desktop-search");

    Array.from(burgerIcons).forEach(item => {
        const openBtn = item.querySelector(".open-search");
        const closeBtn = item.querySelector(".close-search");

        item.addEventListener("click", event => {
            event.stopPropagation();

            const isActive = item.classList.toggle("is-active");
            fullSearch?.classList.toggle("is-active", isActive);

            if (isActive) {
                openBtn?.classList.add("hidden");
                closeBtn?.classList.remove("hidden");
            } else {
                openBtn?.classList.remove("hidden");
                closeBtn?.classList.add("hidden");
            }
        });
    });

    document.addEventListener("click", event => {
        const target = event.target;

        const clickedInsideBurger = [...burgerIcons].some(icon => icon.contains(target));
        const clickedInsideFullSearch = fullSearch?.contains(target);

        if (!clickedInsideBurger && !clickedInsideFullSearch) {
            burgerIcons.forEach(icon => {
                icon.classList.remove("is-active");

                icon.querySelector(".open-search")?.classList.remove("hidden");
                icon.querySelector(".close-search")?.classList.add("hidden");
            });

            fullSearch?.classList.remove("is-active");
        }
    });
}
